import { strings_kr } from "./textStrings/strings_kr.js";

export default {
  kr: {
    home:{
      title: ""
    }
  },
  en: {
    home:{
      title: ""
    }
  }
}

export const strings = {
  kr: strings_kr,
}

export const targetLangs = [
  { name: "KR", displayName: "한국어" },
  { name: "EN", displayName: "English" },
  { name: "JP", displayName: "Japanese" },
  { name: "CN", displayName: "Chinese" },
];
